import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ConversaNutriPage } from '../conversa-nutri/conversa-nutri';
import { ConversaProvider } from '../../providers/conversa/conversa';
import { ViewProvider } from '../../providers/view/view';

@Component({
  selector: 'page-conversa-nutri-list',
  templateUrl: 'conversa-nutri-list.html',
})
export class ConversaNutriListPage {

  conversaAtiva:any;
  conversas:Array<any> = [  ]

  constructor(public navCtrl: NavController, public navParams: NavParams, private view:ViewProvider,private conversaProvider:ConversaProvider) {
  }

  ionViewDidEnter() {
    this.conversaProvider.carregar().subscribe(
      (dados) => {
        
        this.conversas = dados;
        
        if(this.conversas && this.conversas.length && !this.conversas[0].finalizada ){
          this.conversaAtiva = this.conversas[0];
          this.conversas.splice(0, 1);
        }
      }
    );
  }

  abrirNovoChat(){
    this.navCtrl.push(ConversaNutriPage, {conversa:this.conversaAtiva});
  }
  
  visualizar(conversa){
    this.navCtrl.push(ConversaNutriPage, {conversa:conversa});
  }
}



// WEBPACK FOOTER //
// ./src/pages/conversa-nutri-list/conversa-nutri-list.ts